<div *ngIf="view === 'loads'" class="filter-section">
  <div class="date-filters">
    <label>
      Start Date:
      <input type="date" [(ngModel)]="startDate" />
    </label>

    <label>
      End Date:
      <input type="date" [(ngModel)]="endDate" />
    </label>
  </div>

  <div class="filter-buttons">
    <button mat-raised-button color="primary" (click)="page = 1; fetchLoads()">Apply Filter</button>
  </div>
</div>

<mat-card class="order-list-card" *ngIf="view === 'loads' && loads.length > 0">
  <h3 class="card-title">Filtered Loads</h3>
  <app-load-table [loads]="loads"
                  [isDraggable]="false"
                  (loadSelected)="viewLoadDetails($event)">
  </app-load-table>

  <div class="pagination-controls">
    <button mat-button (click)="prevPage()" [disabled]="page === 1">Previous</button>
    <span>Page {{ page }} of {{ totalPages }}</span>
    <button mat-button (click)="nextPage()" [disabled]="page === totalPages">Next</button>
  </div>
</mat-card>

<div *ngIf="view === 'orders'">
  <!-- Load header details -->
  <mat-card *ngIf="selectedLoad" class="order-list-card" style="margin-bottom: 12px;">
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <h3 class="card-title">Load Details</h3>
      <button mat-icon-button 
              color="warn" 
              *ngIf="selectedLoad && selectedLoad.state === 'loaded'" 
              (click)="resetLoadToDraft()"
              matTooltip="Reset to Draft"
              aria-label="Reset to Draft">
        <mat-icon>lock_open</mat-icon>
      </button>
    </div>
    <div>
      <p><strong>Name/No:</strong> {{ selectedLoad.name }} (ID: {{ selectedLoad.id }})</p>
      <p><strong>Salesman:</strong> {{ selectedLoad.salesManName || '—' }}</p>
      <p><strong>Delivery Boy:</strong> {{ selectedLoad.deliveryBoyName || '—' }}</p>
      <p><strong>Created:</strong> {{ selectedLoad.createdAt | date:'medium' }}</p>
      <p><strong>Note:</strong> {{ selectedLoad.note || '—' }}</p>
    </div>
  </mat-card>

  <app-packup-orders-list [orders]="loadOrders" (select)="openOrder($event)"></app-packup-orders-list>
  <div class="action-row">
    <button mat-button class="full-width" (click)="view='loads'">Back to Loads</button>
  </div>
</div>

<div *ngIf="view === 'cart'">
  <!-- Invoice Details Banner -->
  <div *ngIf="isViewingInvoice" class="invoice-banner">
    <mat-card class="invoice-info-card">
      <div class="invoice-info">
        <mat-icon>receipt</mat-icon>
        <span>Viewing Invoice Details (Read-only)</span>
      </div>
    </mat-card>
  </div>

  <app-cart [selectedCustomer]="selectedCustomer"
            [selectedProducts]="selectedProducts"
            (cartUpdated)="onCartUpdated($event)"
            (selectionStateChange)="onSelectionStateChange($event)"
            (editRequested)="productsMode = true"
            [disableDraft]="true"
            [disableOrder]="true"
            [disableEdit]="isReadonly"
            [disableDelete]="true"
            [editButtonLabel]="'Add products'"
            [readonly]="isReadonly"
            [showSelection]="!isReadonly">
  </app-cart>

  <div *ngIf="productsMode" class="product-panel">
    <app-product-list [selectedCustomer]="selectedCustomer!"
                      [selectedProducts]="selectedProducts"
                      (cartUpdated)="onCartUpdated($event)"
                      [products]="products">
    </app-product-list>
    <button mat-raised-button color="primary" class="sticky-button" (click)="productsMode = false">Done Adding</button>
  </div>

  <div class="action-row">
    <button mat-raised-button color="accent" class="full-width" (click)="packAndInvoice()" [disabled]="isReadonly">
      {{ isViewingInvoice ? 'View Invoice Details' : 'Pack and Invoice' }}
    </button>
    <button mat-button class="full-width" (click)="view='orders'">Back to Orders</button>
  </div>
</div>


